import controller from './packet-delete-immediate-success-dialog.controller';

export default {
  controller,
  template: require('./packet-delete-immediate-success-dialog.html')
};



// WEBPACK FOOTER //
// src/app/packet/packet-delete-immediate-success-dialog/packet-delete-immediate-success-dialog.component.ts